<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <div class="mt-4"/>
    <ReportDetailList v-if="this.tag !== 'U1'" data="{tag='K6'}"/>
    <AppNavigationBottom/>
  </div>
</template>
<script>
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import ReportDetailList from "@/engineering/report/components/ReportDetailList";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import { mapGetters } from "vuex";
import pageAccess from "@/frame/control/mixins/pageAccess.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    ReportDetailList
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getCurrentPage",
      "getPreviousPage",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    dis() {
      let dis = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        dis = this.getSearchResults[0].char.dis;
      }
      return dis;
    },
    ver() {
      let ver = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        ver = this.getSearchResults[0].basic.ver;
      }
      return ver;
    },
    AppNavigationTopInfo() {
      let obj = {
        title: "Technical Details",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "person",
            icon: "person",
            link: "/userdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      obj.btns[0].title = "Plan";
      obj.btns[0].icon = "settings";
      obj.btns[0].link = "/facilitydashengineering";
      if (this.dis !== null) {
        obj.title = "Technical Results";
        obj.btns[1].title = "Result ";
        obj.btns[1].icon = "add_chart";
      }
      if (this.getPreviousPage !== "/reportdetaillist") {
        obj.btns[1].link = "/facilitydashreport";
      } else {
        obj.btns[1].link = "/facilitydashengineering";
      }
      return obj;
    }
  },
  mixins: [currentPage, apptheme, storeFunctions, pageAccess, getList],
  data() {
    return {
      currentPagePath: "/reportdetaillist"
    };
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    this.$store.dispatch("changeTreeMasterInfo", null);
    this.$store.dispatch("changeTreeParentInfo", null);
    this.$store.dispatch("changeCommsDialog", false);
    // Reset STORE (previous document data)
    // this.resetStoreDetail();
  },
  mounted() {
    // POssible race condiction with other logic
    this.resetStoreDetail();
  },
  updated() {
    // this.getResultsOnly(this.getSearchResults);
  }
};
</script>
